app.factory('systemApiService', function($http) {
    return {
        list: function(page, params) {
            return $http.get('/administration/systemapi?page=' + page, {
                params: params
            });
        },
        create: function() {
            return $http.get('/administration/systemapi/create');
        },
        store: function(data) {
            return $http.post('/administration/systemapi', data);
        },
        show: function(id) {
            return $http.get('/administration/systemapi/' + id);
        },
        edit: function(id) {
            return $http.get('/administration/systemapi/' + id + '/edit');
        },
        update: function(id, data) {
            return $http.put('/administration/systemapi/' + id, data);
        },
        delete: function(id) {
            return $http.delete('/administration/systemapi/' + id);
        },
    }
});
